<template>
	<div class="accountAnnouncementWrap">
		<div class="accountAnnouncementTitle">Upcoming events:</div>
		<div class="marquee">
			<div class="marqueeRow">

				<account-announcement-item
						v-for="(item, index) in items"
						:key="index"
						:item="item"
				></account-announcement-item>
			</div>
		</div>
	</div>
</template>

<script>
import AccountAnnouncementItem from "@/pages/Account/Announcement/AnnouncementItem.vue";

export default {
	name: "AccountAnnouncement",
	components: { AccountAnnouncementItem },
	props: {
		items: Array,
	},
};
</script>

<style scoped lang="scss">
@-webkit-keyframes scroll {
	0% {
		-webkit-transform: translate(0, 0);
		transform: translate(0, 0);
	}
	100% {
		-webkit-transform: translate(-100%, 0);
		transform: translate(-100%, 0)
	}
}

@-moz-keyframes scroll {
	0% {
		-moz-transform: translate(0, 0);
		transform: translate(0, 0);
	}
	100% {
		-moz-transform: translate(-100%, 0);
		transform: translate(-100%, 0)
	}
}

@keyframes scroll {
	0% {
		transform: translate(0, 0);
	}
	100% {
		transform: translate(-100%, 0)
	}
}

.accountAnnouncementWrap {
	padding-bottom: 10px;
	position: relative;
	display: flex;
	align-items: center;
	gap: 10px;
	.accountAnnouncementTitle {
		white-space: nowrap;
		color: #1dab39;
		font-size: 12px;
		@media screen and (max-width: 1000px) {
			display: none;
		}
	}
	.marquee {
		display: block;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		.marqueeRow {
			display: inline-flex;
			align-items: center;
			gap: 20px;
			padding-left: 100%;
			-webkit-animation: scroll 30s infinite linear;
			-moz-animation: scroll 30s infinite linear;
			animation: scroll 30s infinite linear;
		}
	}
}

</style>
